import { FormControl, FormControlLabel, Grid, Typography } from "@mui/material";
import styles from "../reportSection.module.scss";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomCalendarTodayOutlinedIcon,
  CustomCheckbox,
  CustomDatePicker,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelectforFamily,
  StyledDateContainer,
  formatAmount,
} from "../../common/StyledComponents/StyledFields";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useState, useEffect } from "react";
import { ValidationError, object, string } from "yup";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DietiesListByPoojaIdProps } from "../../../infrastructure/GlobalContextProvider";
import dayjs from "dayjs";
import { isEmpty } from "lodash";
import { PoojaTypeListProps } from "../../../infrastructure/GlobalContextProvider";
import { apiRequest } from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import { isNil } from "lodash";
import { ClipLoader } from "react-spinners";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";

const DailyReport = ({ sendDataToParent, getReportData }: any) => {
  const [poojaItemsList, setPoojaItemsList] = useState<PoojaTypeListProps[]>(
    []
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedPoojaId, setSelectedPoojaId] = useState<number | undefined>(0);

  useEffect(() => {
    apiRequest({
      method: "GET",
      endpoint: apiPath.poojaTypeByPoojaLocation,
      params: {
        poojaType: "TEMPLE_POOJA",
      },
      includeToken: true,
    })
      .then((res) => {
        setPoojaItemsList(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  interface ErrorMessageTypesPooja {
    poojaTitle: string;
    searchbydonation: string;
  }

  const formFieldsPoojaBooking = {
    poojaTitle: "",
    searchbydonation: dayjs().format("MM/DD/YYYY"),
  };
  const validationSchemaForpooja = object().shape({
    poojaTitle: string().required("Pooja is required"),
    searchbydonation: string().required(
      "Search by Donation Date From is required"
    ),
  });

  const [errorMessageBookPooja, setErrorMessageBookPooja] =
    useState<ErrorMessageTypesPooja>({ ...formFieldsPoojaBooking });

  const [formDataBookPooja, setFormDataBookPooja] = useState(
    formFieldsPoojaBooking
  );
  const errors: ErrorMessageTypesPooja = {
    ...formFieldsPoojaBooking,
  };
  const [poojaDeitiesList, setPoojaDeitiesList] = useState<
    DietiesListByPoojaIdProps[]
  >([]);
  const [deityError, setDeityError] = useState<string>("");
  const [allDieties, setAllDieties] = useState<boolean>(false);
  const [selectedDeityIds, setSelectedDeityIds] = useState<number[]>([]);

  const handleCheckboxChange = (label: number) => {
    const isSelected = selectedDeityIds.includes(label);
    setDeityError("");
    if (isSelected) {
      setSelectedDeityIds(selectedDeityIds.filter((item) => item !== label));
    } else {
      setSelectedDeityIds([...selectedDeityIds, label]);
    }
  };

  const getPoojaBookingDailyReports = () => {
    let dieties = poojaDeitiesList.join(",");
    if (allDieties) {
      dieties = "ALL";
    }
    if (poojaDeitiesList.length === 0 && !allDieties) {
      setDeityError("Deity is Mandatory,Please Select Deity.");
    } else {
      const reqBody = {
        poojaId: selectedPoojaId,
        poojaDate: formDataBookPooja.searchbydonation,
      };
      setLoading(true);
      apiRequest({
        method: "POST",
        endpoint:
          "/report-dashboard/reports/pooja/POOJA_BOOKING_DAILY_REPORT/browser",
        body: JSON.stringify(reqBody),
        includeToken: true,
      })
        .then((res) => {
          setLoading(false);
          sendDataToParent(true, reqBody);
          const response = res?.data?.map((obj: any) => {
            return {
              "Devotee Name(Sign-in Name)": `${obj.firstname} ${obj.middlename} ${obj.lastname} (${obj.username})`,
              "Nakshatram": obj.nakshtram,
              "Gothram": obj.gothram,
              "Amount": formatAmount(obj.amount),
            };
          });
          getReportData(response);

        })
        .catch((err) => {
          setLoading(false);
        });
    }
  };

  const getDeitiesListByPoojaId = (id: number | undefined) => {
    if (!isNil(id)) {
      apiRequest({
        method: "GET",
        endpoint: apiPath.deitiesListByPoojaId,
        includeToken: true,
        params: {
          poojaId: id,
        },
      })
        .then((res) => {
          setPoojaDeitiesList(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const handlSubmitDailyreport = async () => {
    try {
      // Validate the form data against the validation schema
      await validationSchemaForpooja.validate(formDataBookPooja, {
        abortEarly: false,
      });
      // If validation passes, you can submit the form
      setErrorMessageBookPooja(errors);
      // Call your API or perform other actions here
      getPoojaBookingDailyReports();
    } catch (error) {
      // Handle validation errors

      if (error instanceof ValidationError) {
        error.inner.forEach((e) => {
          if (e.path) {
            errors[e.path as keyof ErrorMessageTypesPooja] = e.message;
          }
        });
      }
      setErrorMessageBookPooja(errors);
    }
  };

  const handleClear = () => {
    setFormDataBookPooja(formFieldsPoojaBooking);
  };

  const handleDropdownChange = (field: any, value: any) => {
    if (field === "searchbydonation") {
      const formattedDate = dayjs(value, "MM/DD/YYYY");

      setFormDataBookPooja({
        ...formDataBookPooja,
        [field]: formattedDate.isValid()
          ? formattedDate.format("MM/DD/YYYY")
          : "",
      });
    } else {
      setFormDataBookPooja({
        ...formDataBookPooja,
        [field]: value,
      });
    }
    if (field === "poojaTitle") {
      const selectedPooja = poojaItemsList.find(
        (item: PoojaTypeListProps) => item.name === value
      );
      setSelectedPoojaId(selectedPooja?.id);
      getDeitiesListByPoojaId(selectedPooja?.id);
    }
  };

  const handleAllDeitiesChange = (event: any) => {
    const isChecked = event.target.checked;
    setAllDieties(isChecked);
    setDeityError("");
  };
  const PoojaListDropdown = (): React.ReactElement => {
    return (
      <>
        <FormControl className={styles.moveToDropdown}>
          <CustomSelectforFamily
            IconComponent={KeyboardArrowDownIcon}
            defaultValue=""
            id="grouped-select"
            value={formDataBookPooja.poojaTitle}
            onChange={(e) => {
              handleDropdownChange("poojaTitle", e.target.value);
              setErrorMessageBookPooja({
                ...errorMessageBookPooja,
                poojaTitle: "",
              });
            }}
            MenuProps={{
              PaperProps: {
                sx: {
                  border: "1px solid #F05802",
                  "& ul": {
                    paddingTop: 0,
                    paddingBottom: 0,
                    overflowY: "auto",
                    minHeight: "auto",
                    maxHeight: "300px",
                    "&::-webkit-scrollbar": {
                      width: "8px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#F3C539",
                      borderRadius: "6px",
                    },
                  },
                },
              },
            }}
            className={
              errorMessageBookPooja.searchbydonation
                ? styles.errorTextField
                : styles.dateFeildforfamily
            }
          >
            {poojaItemsList.map((item: any, i: any) => (
              <CustomMenuItem value={item.name} key={i}>
                {item.name}
              </CustomMenuItem>
            ))}
          </CustomSelectforFamily>
        </FormControl>
        {errorMessageBookPooja.poojaTitle && (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessageBookPooja.poojaTitle}
          </Typography>
        )}
      </>
    );
  };

  const DobDatePickerDailyReport = (): React.ReactElement => {
    return (
      <div className={styles.dateconatiner}>
        <StyledDateContainer className={styles.styledConatiner}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DateTimePicker"]}>
              <CustomDatePicker
                slots={{
                  openPickerIcon: CustomCalendarTodayOutlinedIcon,
                }}
                slotProps={{
                  inputAdornment: {
                    position: "end",
                  },
                }}
                format="MM-DD-YYYY"
                value={
                  formDataBookPooja.searchbydonation
                    ? dayjs(formDataBookPooja.searchbydonation, "MM-DD-YYYY")
                    : ""
                }
                onChange={(value) => {
                  handleDropdownChange("searchbydonation", value);
                }}
                disableFuture
                className={styles.dateFeildforfamily}
              />
            </DemoContainer>
          </LocalizationProvider>
        </StyledDateContainer>
      </div>
    );
  };

  const deitiesListComponent = () => {
    return (
      <div style={{ width: "100%" }}>
        <div className={styles.checkBoxContainer}>
          {poojaDeitiesList.map((item: DietiesListByPoojaIdProps, index) => (
            <div className={styles.checkTitle}>
              <FormControlLabel
                control={
                  <CustomCheckbox
                    id={`${index}`}
                    size="medium"
                    className={styles.checkbox}
                    checked={selectedDeityIds.includes(item.deityId)}
                    onChange={() => handleCheckboxChange(item.deityId)}
                  />
                }
                label={item.deityName}
              />
            </div>
          ))}
        </div>
        {!isEmpty(deityError) ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {deityError}
          </Typography>
        ) : (
          ""
        )}
      </div>
    );
  };
  return (
    <div className={styles.poojareportsLayout}>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Pooja", true)}
          {PoojaListDropdown()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Search by Donation Date From", true)}
          {DobDatePickerDailyReport()}
        </Grid>
      </Grid>
      <Grid container spacing={2} sx={{ mt: 0 }}>
        <Grid item xs={12} sm={4}>
          {CustomRequiredInputLabel("Deities", true)}
          {deitiesListComponent()}
        </Grid>
        <Grid xs={12} item sx={{ display: "flex", gap: "16px" }}>
          <FormControlLabel
            control={
              <CustomCheckbox
                checked={allDieties}
                onChange={handleAllDeitiesChange}
              />
            }
            label="All Deities"
            sx={{
              color: "#000",
              fontSize: "16px",
            }}
          />
        </Grid>
        {!isEmpty(deityError) ? (
          <Typography
            sx={{ color: "red", fontSize: "12px", marginLeft: "17px" }}
          >
            {deityError}
          </Typography>
        ) : (
          ""
        )}
      </Grid>
      <Grid sx={{ mt: 3, display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitDailyreport}
          disabled={loading}
          id="submit"
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
      </Grid>
    </div>
  );
};
export default DailyReport;
